<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="6">
      <v-card elevation="8" rounded="lg" class="text-center pa-6">
        <v-icon size="64" color="grey darken-1" class="mb-4">
          mdi-clock-outline
        </v-icon>
        <h2 class="text-h4 font-weight-bold mb-2">
          {{ $t('common.notAvailableYet') }}
        </h2>
        <p class="text-subtitle-1 text-medium-emphasis">
          {{ $t('common.checkBackLater') }}
        </p>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup></script>
